import React, { useEffect, useState } from "react";
import { notification } from 'antd';
import dayjs from 'dayjs';
import { DescriptionText, FlexContainer, H1Text, H2Text, Spinner } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import { orderChargeById, BASE_URLS, declineWoocommerceOrderByGid, getWoocommerceById, getSecretValuesById, getCheckoutReconnection, getQrPaymentReconnection, getHealthCheck } from "../../api";
import { MESSAGES, WOOCOMMERCE_ORDER_STATUSES, SWIREPAY_URL, TabNames, NETBANKING_LIST, QR_STATUSES, TANGEDCO_PG, SESSION_TIME, LPG_CUSTOMER } from "../../appconstants";
import { AmountDivideByHundred } from "../../helper";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import SmallScreenFooter from "../../components/footer";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import getMenuTabs from "../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import getRedirectionUrl from "../../utils/getRedirectionUrl";
import UpiPayment from "../../components/upipayment/UpiPayment";
import AchPayment from "../../components/achPaymentWithPlaid";
import InstantPayment from "../../components/instantpayment/InstantPayment";
import GooglePay from "../../components/googlePay/GooglePay";
import BankPayment from "../../components/bankpayment/BankPayment";
import NetBanking from "../../components/netbanking/NetBanking";
import PaymentMethodTabs from "../../components/paymentmethodtabs";
import AlertModal from "../../components/modal/alert";
import WARNING_ICON from "../../assets/imgs/exclamation_warning.svg"
import SUCCESS_ICON from "../../assets/imgs/success.svg";
import Logo from "../../assets/imgs/swirepay-logo.svg";
import EPaymentImg from "../../assets/imgs/e payments.svg";
import OMEGAITRlogo from "../../assets/imgs/OmegaITRlogo.png";
import UPIIMAGE from "../../assets/imgs/upiNotification.svg";

type Props = {
    history: {
        push: Function,
    },
}

const WoocommerceOrder = (props: Props) => {

    const { match: { params: { woocommerceOrderId } }, location: { pathname, search } } = props;
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
    const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${woocommerceOrderId}-tap-index`) || 0));
    const [tabName, setTabName] = useState('');
    const [banksList, setBanksList] = useState(null);
    const [isTest, setIsTest] = useState(null);
    const [bankTypes, supportedBankTypes] = useState([null]);
    const [bankImageUrl, setBankImageUrl] = useState(null);
    const [partnerImageUrl, setPartnerImageUrl] = useState(null);
    const [gpaySecretValues, setGpaySecretValues] = useState(null);
    const [gpayError, setGpayError] = useState(null);
    const [processStatus, setProcessStatus] = useState(false);
    const [applePayment, setApplePayment] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState('');
    const [declineUrl, setDeclineUrl] = useState('');
    const [upiDownTime, setUpiDownTime] = useState(false);
    const hostName = (window && window.location && window.location.host);
    const [swirepayUS, setSwirepayUS] = useState(false);
    const [googlePayUs, setGooglePayUs] = useState(false);
    const accountGid = [
      'account-cdfe7eecff324778a88a2727177a1c8f'
    ];
    const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${woocommerceOrderId}`) || undefined);
    const defaultAlertConfig = {
        showIcon: false, isOpen: false, hideBtn: true,
        cancel: null, header: null, body: null,
        submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
        showSubmitBtn: false, submit: null, icon: null
    };

    const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);
    const [ipAddress, setIpAddress] = useState('');

    const getData = async () => {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
      }
    
      useEffect(() => {
        getData();
      }, []);

    useEffect(() => {
        if (search) {
            getWoocommerceDataWithSearchValue();
        } else {
            getWoocommerceDataWithoutSearchValue();
        }
    }, [woocommerceOrderId, search]);

    useEffect(() => {
        if (payment && payment.currency && payment.amount) {
            setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(payment.amount), payment.currency.name)}`)
        }
        setSwirepayUS(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US'));
        setGooglePayUs(payment && payment.account && payment.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
    }, [payment]);

    useEffect(() => {
        setErrorMessage(null);
    }, [selectedTab]);

    const getWoocommerceDataWithSearchValue = async () => {
        const params = new URLSearchParams(search);
        if (!(params.get('ps') || params.get('mp')) || !params.get('secret')) {
            props.history.push(`${pathname}/error`);
            return;
        }
        setShowSpinner(true);
        try {
            const value = await getWoocommerceById(woocommerceOrderId, search);
            if (value) {
                const { redirectUri, spOrderStatus, receiptNumber } = value;
                const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (WOOCOMMERCE_ORDER_STATUSES.CREATED !== spOrderStatus) {
                    if (!redirectUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const uri = getRedirectionUrl(hostName);
                        if (redirectUri) {
                            window.location = `${redirectUri}`;
                        } else if (uri) {
                            window.location = `${uri}receipts/${receiptNumber}`;
                        }
                    }, timeOut);
                }
            }
        } catch (reason) {
            try {
                const value = await getWoocommerceById(woocommerceOrderId, null);
                if (value) {
                    setPayment(value);
                }
            } catch (e) {
                props.history.push(`${pathname}/error`);
            }
            error(reason);
        } finally {
            setShowSpinner(false);
        }
    };

    const error = reason => {
        setErrorMessage(null);
        const { data: { message, messageCode }, status } = reason;
        if (MESSAGES.PAYMENT_LINK.EXPIRED === message) {
            props.history.push(`${pathname}/expired`)
        } else {
            if (messageCode === 5102) {
                props.history.push(`${pathname}/error`);
                return;
            }
            setErrorMessage(message);
            if (status === 500) {
                setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
            }
            resetAlertConfig();
            setTransactionModalOpen(false);
            const errorEl = document.getElementById("error");
            if (null !== errorEl) { errorEl.scrollIntoView(); }
        }
    };

    const getGooglePayMerchantValues = async (accountGid) => {
        try {
            const values = await getSecretValuesById(accountGid, null);
            setGpaySecretValues(values);
        } catch (error) {
            setGpayError('Missing merchant details. Please contact support');
        }
    };

    const getWoocommerceDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getWoocommerceById(woocommerceOrderId, null);
            if (value) {
                const { spOrderStatus, redirectUrl, declineUrl } = value;
                setRedirectUrl(redirectUrl || SWIREPAY_URL);
                setDeclineUrl(declineUrl || SWIREPAY_URL);
                if (WOOCOMMERCE_ORDER_STATUSES.CREATED !== spOrderStatus) {
                    props.history.push(`${pathname}/expired`);
                    return;
                }
                // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
                //     const val = await getHealthCheck();
                //     if (val && val.status !== 'ACTIVE') {
                //         setUpiDownTime(true);
                //         notification.open({
                //             message: '',
                //             description: <img src={UPIIMAGE} alt="" />,
                //           });
                //     }
                //   }
                setPayment(value);
                setBackButtonUrl(redirectUrl || SWIREPAY_URL)
            }
        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const getCustomerGidFromPayment = () => {
        return payment && payment.customer && payment.customer.gid;
    };

    const chargeByUpi = async (data) => {
        const { customer, paymentMethod, notify } = data;
        await chargeById({ customer, paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByAch = async (data) => {
        const { customer, paymentMethod } = data;
        await chargeById({ customer, paymentMethod });
    };

    const chargeByCard = async (data) => {
        const { customer, paymentMethod } = data;
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8", 
            ip: ipAddress,
            language: window.navigator.language, 
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height, 
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(), 
            browserUserAgent: window.navigator.userAgent
           };
           paymentMethod.userAgent = userAgent;
        await chargeById({ customer, paymentMethod });
    };

    const chargeByBank = async (data) => {
        const { fundingSourceId } = data;
        const paymentMethod = {
            type: "ACH",
            bank: {
                referenceId: fundingSourceId,
            },
        };
        await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByNetBanking = async (data) => {
        const { gid, notify } = data;
        const paymentMethod = {
            type: "NET_BANKING",
            netbanking: {
                swirepayBankGid: gid,
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByInstantPay = async (data) => {
        const { walletAlias, notify } = data;
        const paymentMethod = {
            type: "INSTANT_PAYMENT",
            instantPayment: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeBySwirepayUS = async (data) => {
        const { walletAlias, notify } = data;
        const paymentMethod = {
            type: "WALLET",
            subType: "SWIREPAY_US",
            swirepayUS: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeById = async (data) => {
        setTransactionModalOpen(true);
        try {
            const value = await orderChargeById(woocommerceOrderId, data);
            if (value) {
                const { paymentSession, redirectUri, paymentStatus } = value;
                const nextActionUrl = paymentSession && paymentSession.nextActionUrl;
                if (paymentStatus && paymentStatus === 'PROCESSING') {
                    setProcessStatus(true);
                }
                if (nextActionUrl) {
                    window.location = nextActionUrl;
                    return;
                }
                const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                setTransactionModalOpen(false);
                if (!redirectUri) {
                    setTransactionSuccessModalOpen(true);
                }
                setTimeout(function () {
                    window.location = redirectUrl;
                    sessionStorage.removeItem("stripeRes");
                }, timeOut);
                if (woocommerceOrderId) { localStorage.removeItem(`${woocommerceOrderId}-tap-index`) }
            }
        } catch (reason) {
            error(reason);
            return reason;
        }
    };

    const cancelAlertOpen = () => {
        setAlertConfig({
            showIcon: true, isOpen: true, hideBtn: false,
            cancel: resetAlertConfig, header: "Are you sure!", body: "You will not be able to recover this order",
            submitBtnText: "Yes, decline it!", cancelBtnText: "Cancel", showCancelBtn: true,
            showSubmitBtn: true, submit: declineWoocommerceOrder, icon: WARNING_ICON
        });
    };

    const resetAlertConfig = () => {
        setAlertConfig(defaultAlertConfig)
    };

    const getPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getCheckoutReconnection(paymentSession, psClientSecret);
            if (value) {
                const { status, receiptNumber } = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const uri = getRedirectionUrl(hostName);
                        const redirectUrl = redirectionUri ? redirectionUri : '';
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}`;
                        } else if (redirectUrl && !urlPath) {
                            window.location = `${redirectUrl}`;
                        } else if (uri) {
                            window.location = `${uri}receipts/${receiptNumber}`;
                        }
                    }, timeOut);
                    if (woocommerceOrderId) { localStorage.removeItem(`${woocommerceOrderId}-tap-index`) }
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
            if (value) {
                const { status, receiptNumber } = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const uri = getRedirectionUrl(hostName);
                        const redirectUrl = redirectionUri ? redirectionUri : '';
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}`;
                        } else if (redirectUrl && !urlPath) {
                            window.location = `${redirectUrl}`;
                        } else if (uri) {
                            window.location = `${uri}receipts/${receiptNumber}`;
                        }
                    }, timeOut);
                    if (woocommerceOrderId) { localStorage.removeItem(`${woocommerceOrderId}-tap-index`) }
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const declineWoocommerceOrder = () => {
        setAlertConfig({
            ...defaultAlertConfig,
            showIcon: true, isOpen: true, hideBtn: true,
            header: `Please Wait!. Your order decline is being processed`, body: "You will be redirected when the decline is successful.",
        });
        if (payment && payment.gid) {
            declineWoocommerceOrderByGid(payment.gid).then(value => {
                if (value) {
                    const timeOut = declineUrl ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                    setAlertConfig({
                        ...defaultAlertConfig,
                        showIcon: true, isOpen: true, hideBtn: true,
                        header: "Order Cancellation Completed", body: "You will be redirected automatically.",
                        icon: SUCCESS_ICON
                    });
                    setTimeout(function () {
                        const redirectUrl = declineUrl || SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        const decline = "decline=true";
                        if (urlPath) {
                            window.location = `${redirectUrl}&${decline}`;
                        } else if (redirectUrl && !urlPath) {
                            window.location = `${redirectUrl}?${decline}`;
                        }
                    }, timeOut);
                }
            }).catch(reason => error(reason));
        }
    };

    const chargeByGooglePay = async (data) => {
        const paymentMethod = {
            type: "WALLET",
            subType: "GOOGLE_PAY_US",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };
        await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByApplePay = async (stripePaymentMethod) => {
        // const meta = stripePaymentMethod;
        const paymentMethod = {
            applePayUS: {
                  stripePaymentMethodId: stripePaymentMethod.id,
                  cardBrand: stripePaymentMethod.card.brand,
                  cardExpMonth: stripePaymentMethod.card.exp_month,
                  cardExpYear: stripePaymentMethod.card.exp_year,
                  cardFundingType: stripePaymentMethod.card.funding,
                  applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
                  cardLast4: stripePaymentMethod.card.last4,
                  billingAddress: {
                    street: stripePaymentMethod.billing_details.address.line1,
                    city: stripePaymentMethod.billing_details.address.city,
                    state: stripePaymentMethod.billing_details.address.state,
                    postalCode: stripePaymentMethod.billing_details.address.postal_code,
                    countryCode: stripePaymentMethod.billing_details.address.country
                  },
                  name: stripePaymentMethod.billing_details.name,
                  email: stripePaymentMethod.billing_details.email,
                  phone: stripePaymentMethod.billing_details.phone
                },
                customerGid: getCustomerGidFromPayment(payment),
                type: "WALLET",
                subType: "APPLE_PAY_US",
                rawData: {
                  stripePaymentMethodId: stripePaymentMethod.id,
                  cardBrand: stripePaymentMethod.card.brand,
                  cardExpMonth: stripePaymentMethod.card.exp_month,
                  cardExpYear: stripePaymentMethod.card.exp_year,
                  cardFundingType: stripePaymentMethod.card.funding,
                  applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
                  cardLast4: stripePaymentMethod.card.last4,
                  billingAddress: {
                    street: stripePaymentMethod.billing_details.address.line1,
                    city: stripePaymentMethod.billing_details.address.city,
                    state: stripePaymentMethod.billing_details.address.state,
                    postalCode: stripePaymentMethod.billing_details.address.postal_code,
                    countryCode: stripePaymentMethod.billing_details.address.country
                  },
                  name: stripePaymentMethod.name,
                  email: stripePaymentMethod.email,
                  phone: stripePaymentMethod.phone
                }
              }
        await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const uniquePaymentTypes =paymentTypeOrder ? paymentTypeOrder.map((res) => res ? res.category : null) : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
    if(uniquePaymentTypes.includes('WALLET')) {
        if (swirepayUS) {
            uniquePaymentTypes.push('SWIREPAY_US');
        }
        if (!googlePayUs) {
            const index = uniquePaymentTypes.indexOf('WALLET');
            if (index > -1) {
                uniquePaymentTypes.splice(index, 1);  // Removes the 'WALLET' from the array
            }
        } 
    }
    const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
        let children;
        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerDisabled={true}
                headerText={accountGid.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={woocommerceOrderId}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true} 
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={payment ? `${currencyFormatter(AmountDivideByHundred(payment.amount), payment.currency && payment.currency.name)}` : null}
            />
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                showCancelBtn={payment && payment.declineUrl}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillWCCustomer={payment}
                headerText={"Pay With Card"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                tabName={tabName}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                customerValidation={true}
                requiredPhone={true}
                showWhatsAppNotify={false}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                wcalpha2={payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2}
                ApplePayment={applePayment}
                payment={payment}
                chargeByApplePay={chargeByApplePay}
            />
        } else if (name === TabNames.UPI) {
            children = <UpiPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByUpi}
                preFillCustomer={payment}
                headerText={"Pay With UPI"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                showMobileViewUpi={true}
                hideQr={false}
                showWhatsAppNotify={false}
                getPaymentById={getPaymentById}
                supportedPaymentTypes={payment && payment.account && payment.account.supportedPaymentTypes}
                upiUrl={`${BASE_URLS.PAYMENT_LINK}/${woocommerceOrderId}`}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
        } else if (name === TabNames.ACH) {
            children = <BankPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerDisabled={false}
                submit={chargeByBank}
                preFillCustomer={payment}
                headerText={"Pay With Bank Transfer"}
                buttonText={submitBtnText}
                showWhatsAppNotify={false}
                woocommerceOrderId={woocommerceOrderId}
                iavUrl={`${BASE_URLS.PAYMENT_LINK}/${woocommerceOrderId}`}
                customerValidation={true}
                cancelButtonText={"Decline"}
                requiredPhone={false}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
            />
        } else if (name === TabNames.NET_BANKING) {
            children = <NetBanking
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByNetBanking}
                preFillCustomer={payment}
                showWhatsAppNotify={false}
                headerText={"PAY WITH NET BANKING"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                banksList={banksList}
                bankTypes={bankTypes}
                isTest={isTest}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
        } else if (name === TabNames.GOOGLE_PAY_US) {
            children = <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                payment={payment}
                chargeByGooglePay={chargeByGooglePay}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorMsg={errorMessage}
                errorHeader={null}
            />
        } else if (name === TabNames.WALLET) {
            children = <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                payment={payment}
                chargeByGooglePay={chargeByGooglePay}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorMsg={errorMessage}
                errorHeader={null}
            />
        } else if (name === TabNames.INSTANT_PAYMENT) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByInstantPay}
                preFillCustomer={payment}
                customerDisabled={true}
                headerText={null}
                buttonText={submitBtnText}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                showWhatsAppNotify={false}
                upiUrl={`${BASE_URLS.PAYMENT_LINK}/${woocommerceOrderId}`}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
        } else if (name === TabNames.SWIREPAY_US) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeBySwirepayUS}
                preFillCustomer={payment}
                customerDisabled={true}
                headerText={null}
                buttonText={submitBtnText}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                showWhatsAppNotify={false}
                upiUrl={`${BASE_URLS.PAYMENT_LINK}/${woocommerceOrderId}`}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                swirepayUS={swirepayUS}
            />
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({ children });
        return panel;
    }, []) : [
        {
            children: <CardPayment
                showCancelBtn={payment && payment.declineUrl}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillWCCustomer={payment}
                headerText={"Pay With Card"}
                cancelButtonText={"Cancel"}
                buttonText={submitBtnText}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                customerValidation={true}
                showWhatsAppNotify={false}
                requiredPhone={true}
                tabName={tabName}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                wcalpha2={payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2}
                ApplePayment={applePayment}
                payment={payment}
                chargeByApplePay={chargeByApplePay}
            />
        }
    ];

    useEffect(() => {
        setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
    }, [selectedTab, uniquePaymentTypes]);
    const agregatorName = payment && payment.account && payment.account.aggregatorName;
    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        {
                            (payment && payment.account && payment.account.largeLogo) && (
                                <img src={payment.account.largeLogo} style={{ width: "125px" }} alt="" />
                            )
                        }
                        {/* <H1Text>
                            Payment Checkout
                        </H1Text> */}
                        <H2Text>
                            Payment For
                        </H2Text>
                        <DescriptionText>
                            {payment && payment.description}
                        </DescriptionText>
                        <H2Text>
                            Amount Payable
                        </H2Text>
                        <DescriptionText fontSize="24px">
                            {payment ? `${currencyFormatter(AmountDivideByHundred(payment.amount), payment.currency && payment.currency.name)}` : null}
                        </DescriptionText>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={payment && payment.support && payment.support.email}
                            phone={payment && payment.support && payment.support.phone}
                            partnerImageUrl={partnerImageUrl}
                            bankImageUrl={bankImageUrl}
                            whiteLabel={payment && payment.account && payment.account.whiteLabel}
                        />
                        {agregatorName === 'EPAYMENTS' ?
                            <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                <a href="https://www.swirepay.com" target="_blank" >
                                    <img src={EPaymentImg} alt="" />
                                </a>
                            </div>
                            :
                            agregatorName === 'OMEGAITR' ?
                                <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                    <a href="https://www.swirepay.com" target="_blank" >
                                        <img src={OMEGAITRlogo} alt="" />
                                    </a>
                                </div>
                                :
                                ''
                        }
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header 
                    payment={payment} 
                    bankImageUrl={bankImageUrl}
                    cancelUrlLink={null} 
                />
                <PaymentMethodTabs
                    name={woocommerceOrderId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={getMenuTabs(uniquePaymentTypes)}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    accountGid={payment?.account?.gid}
                />
                <SmallScreenFooter
                    partnerImageUrl={partnerImageUrl}
                    bankImageUrl={bankImageUrl}
                    whiteLabel={payment && payment.account && payment.account.whiteLabel}
                />
                <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                <SuccessModal isOpen={isTransactionSuccessModalOpen} processing={processStatus} />
                <AlertModal
                    showIcon={alertConfig.showIcon}
                    isOpen={alertConfig.isOpen}
                    hideBtn={alertConfig.hideBtn}
                    cancel={alertConfig.cancel}
                    header={alertConfig.header}
                    body={alertConfig.body}
                    submitBtnText={alertConfig.submitBtnText}
                    cancelBtnText={alertConfig.cancelBtnText}
                    showCancelBtn={alertConfig.showCancelBtn}
                    showSubmitBtn={alertConfig.showSubmitBtn} submit={alertConfig.submit} icon={alertConfig.icon} />
                <Spinner isOpen={isShowSpinner} />
            </>
        } />
    )
};

export default WoocommerceOrder;
